<template>
    <button class="fixed bottom-5 right-5 rounded-full bg-brand w-10 h-10 flex hover:bg-brand-dark transition-all" @click="stopImpersonating">
        <i class="fa-sharp fa-light fa-user-ninja m-auto text-white"/>
    </button>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/user.js";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
const stopImpersonating = async () => {
    try {
        const redirect = `/admin/resources/users/${user.value.id}`;
        await axios.get('/api/impersonation');
        window.location.href = redirect;
    } catch (error) {
        console.error(error);
    }
}
</script>
